import React, { useContext } from 'react';
import { AppContext } from '../../../modules/contexts/AppContexts';
import LoginCard from './LoginCard';
import IntroCard from './IntroCard';
import RegisterCard from './RegisterCard';
import { PasswordResetModal } from './ResetPasswordModal';
import AccountTypeSelector from './AccountTypeSelector';

const AuthCard = () => {
    const { setStartAuth, authStep, setAuthStep } = useContext(AppContext);

    const closeMethod = () => {
        setStartAuth(false);
    };

    const switchToLogin = () => {
        setAuthStep('login');
    };
    
    const switchToIntro = () => {
        setAuthStep('intro');
    };
    
    const switchToResetPassword = () => {
        setAuthStep('resetPassword');
    };
    
    const switchToRegisterUser = () => {
        setAuthStep('registerUser');
    };
    
    const switchToRegisterBiz = () => {
        setAuthStep('registerBusiness');
    };
    return (
        <div className='w-full'>
            {authStep === 'login' && (
                <LoginCard 
                    switchToSignUp={() => setAuthStep('intro')}
                    switchToResetPassword={() => setAuthStep('resetPassword')}
                />
            )}
            
            {authStep === 'intro' && (
                <IntroCard
                    switchToLogin={() => setAuthStep('login')}
                    switchToRegisterUser={() => setAuthStep('registerUser')}
                    switchToRegisterBiz={() => setAuthStep('registerBusiness')}
                />
            )}
            
            {authStep === 'registerUser' && (
                <RegisterCard 
                    closeAuth={closeMethod} 
                    userIsBusiness={false} 
                    switchToLogin={() => setAuthStep('login')} 
                />
            )}
            
            {authStep === 'registerBusiness' && (
                <RegisterCard 
                    closeAuth={closeMethod} 
                    userIsBusiness={true} 
                    switchToLogin={() => setAuthStep('login')} 
                />
            )}
            
            {authStep === 'resetPassword' && (
                <PasswordResetModal 
                    switchToLogin={() => setAuthStep('login')} 
                />
            )}
            
            {authStep === 'accountType' && (
                <AccountTypeSelector />
            )}
        </div>
    );
};

export default AuthCard;